/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PRICE_TABLEHEAD } from '../../../utility/tableHeads';
import PriceInputContainer from './PriceInputContainer';
import PriceTableComponent from './PriceTableComponent';
import { checkActionAccessByRole } from '../../../../../../SharedModules/utilities/utilities';

const Price = (props) => {
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );
  const priceTypeDetails = useSelector(
    (state) => state.sharedState.ndc.priceTypeDetails
  );

  const [selectedPriceType, setSelectedPriceType] = useState(null);
  const { fullScreen, setFullScreen } = { ...props };
  useEffect(() => {
    setSelectedPriceType(null);
  }, [currentNDCDetailsSelected]);
  return (
    <div className="row">
      {!fullScreen && (
        <>
          <PriceInputContainer
            selectedPriceType={selectedPriceType}
            setSelectedPriceType={setSelectedPriceType}
            priceTypeDetails={priceTypeDetails}
            details={
              (currentNDCDetailsSelected &&
                currentNDCDetailsSelected.priceVOs) ||
              []
            }
          />
        </>
      )}

      <PriceTableComponent
        selectedPriceType={selectedPriceType}
        isEnablebyRole={isEnablebyRole}
        tableData={
          (currentNDCDetailsSelected && currentNDCDetailsSelected.priceVOs) ||
          []
        }
        tableHead={
          priceTypeDetails.find((o) => o.priceTypeCd === selectedPriceType)
            ?.allowEntryInd
            ? PRICE_TABLEHEAD
            : PRICE_TABLEHEAD.filter((o) => o.headerName !== 'Target Qtr')
        }
        {...props}
      />
    </div>
  );
};

export default Price;
